import { styled } from '@mui/material/styles';
import { TableContainer, TableHead, TableRow, TableCell } from '@mui/material';

interface StyledTableContainerProps {
  borderRadius?: string;
  marginTop?: string;
  border?: string;
}

interface StyledTableHeadProps {
  bgColor?: string;
  textColor?: string;
  fontWeight?: number;
  fontSize?: string;
  padding?: string;
}

interface StyledTableRowProps {
  evenBgColor?: string;
  hoverBgColor?: string;
}

interface StyledTableCellProps {
  fontSize?: string;
  textColor?: string;
  padding?: string;
}

export const StyledTableContainer = styled(TableContainer, {
  shouldForwardProp: (prop) =>
    !['borderRadius', 'marginTop', 'border'].includes(prop as string),
})<StyledTableContainerProps>(({ borderRadius, marginTop, border }) => ({
  boxShadow: 'none',
  border: border || '1px solid var(--border)',
  borderRadius: borderRadius || '8px',
  marginTop: marginTop || '10px',
}));

export const StyledTableHead = styled(TableHead, {
  shouldForwardProp: (prop) =>
    !['bgColor', 'textColor', 'fontWeight', 'fontSize', 'padding'].includes(
      prop as string
    ),
})<StyledTableHeadProps>(
  ({ bgColor, textColor, fontWeight, fontSize, padding }) => ({
    backgroundColor: bgColor || 'var(--table-header)',
    '& .MuiTableCell-head': {
      color: textColor || 'var(--primary-navy)',
      fontWeight: fontWeight || 600,
      fontSize: fontSize || '14px',
      fontFamily: 'Outfit',
      padding: padding || '12px 16px',
    },
  })
);

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) =>
    !['evenBgColor', 'hoverBgColor'].includes(prop as string),
})<StyledTableRowProps>(({ evenBgColor, hoverBgColor }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: evenBgColor || 'var(--table-row-even)',
  },
  '&:hover': {
    backgroundColor: hoverBgColor || 'var(--table-row-hover)',
  },
}));

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) =>
    !['fontSize', 'textColor', 'padding'].includes(prop as string),
})<StyledTableCellProps>(({ fontSize, textColor, padding }) => ({
  fontFamily: 'Outfit',
  fontSize: fontSize || '14px',
  color: textColor || 'var(--primary-navy)',
  padding: padding || '12px 16px',
}));
